import AppBarProfile from './AppBarProfile';

export default AppBarProfile;
